import parse from "html-react-parser"
import { useTranslation } from "react-i18next"

import { Info } from "@/components/icons"
import { DosAndDontsCard } from "@/features/training/components/dos-and-donts-card"
import { CourseLayout } from "@/features/training/components/layouts/course-layout"
import { CourseSection } from "@/features/training/components/layouts/course-section"

export function SecurityGeneralPage() {
  const { t } = useTranslation("", { keyPrefix: "training.security.content" })
  const { t: tComp } = useTranslation("", { keyPrefix: "training.components" })

  return (
    <CourseLayout>
      <CourseSection>
        <h2>{t("risk_external_ai_services_header")}</h2>
        <p>{parse(t("risk_external_ai_services_intro"))}</p>
      </CourseSection>
      <CourseSection>
        <h3>{t("data_leakage_header")}</h3>
        <p>{parse(t("data_leakage"))}</p>
        <img
          alt="Description"
          className="shadow-x border-border h-auto w-full rounded-lg border"
          src="/assets/training_images/security/data_leakage.webp"
        />
      </CourseSection>
      <CourseSection>
        <h3>{t("data_rights_header")}</h3>
        <p>{parse(t("data_rights"))}</p>
      </CourseSection>
      <p>{parse(t("regulatory_noncompliance"))}</p>
      <CourseSection>
        <h3>{t("incident_examples_header")}</h3>
        <p>{parse(t("incident_examples"))}</p>
      </CourseSection>
      <CourseSection>
        <h3>{t("it_security_risks_header")}</h3>
        <p>{parse(t("it_security_risks_intro"))}</p>
        <img
          alt="Description"
          className="shadow-x border-border h-auto w-full rounded-lg border"
          src="/assets/training_images/security/security.webp"
        />
      </CourseSection>
      <CourseSection>
        <h3>{t("access_security_header")}</h3>
        <p>{parse(t("access_security"))}</p>
      </CourseSection>
      <CourseSection>
        <h3>{t("ai_misuse_header")}</h3>
        <p>{parse(t("ai_misuse"))}</p>
      </CourseSection>

      {/* Rule of thumb */}
      <CourseSection>
        <div className="bg-primary/5 border-primary/20 flex items-start gap-3 rounded-xl border p-5">
          <Info className="text-primary mt-0.5 h-5 w-5 shrink-0" />
          <div>
            <p className="font-semibold">{tComp("rule_of_thumb.title", "Rule of Thumb")}</p>
            <p className="text-sm">
              {tComp(
                "rule_of_thumb.text",
                "If you would send the data via email, Teams, or store it on SharePoint — you can also share it with {{appName}}."
              )}
            </p>
          </div>
        </div>
      </CourseSection>

      {/* Do's and Don'ts */}
      <CourseSection>
        <h2>{tComp("dos_donts.title", "Do's & Don'ts")}</h2>
        <DosAndDontsCard />
      </CourseSection>
    </CourseLayout>
  )
}
